<div class="recent-products" *ngIf="!!recentProducts.length">
  <vw-product-carousel
    [title]="'recentProducts.title' | translate"
    [items]="recentProducts"
    [backgroundColor]="productCarouselBackgroundColor"
  ></vw-product-carousel>
</div>
